export const TABLE_TITLE_COLUMN_TEXT = {
  MAX_WIDTH: "20vw",
} as const;
